module.exports = __webpack_public_path__ + "static/media/Group 1581@3x.1c824a66.png";